'use client'
import { Button } from '@/core/ui/atoms/button'
import { useTranslations } from 'next-intl'
import { PaymentStrategy } from './type'

const Fragment: React.FC<{
  children: React.ReactNode
}> = ({ children }) => <>{children}</>

export const useWalletStrategy: PaymentStrategy = ({
  isConfirmPaymentPending,
}) => {
  const t = useTranslations()
  return {
    Button: (
      <Button
        type='submit'
        loading={isConfirmPaymentPending}
        className='h-11 w-56 self-end'
      >
        {t('actions.confirmPayment')}
      </Button>
    ),
    Form: null,
    Provider: Fragment,
  }
}
